import template from './registry.html';
import controller from './registry.controller.js';

const profileRegistryComponent = {
  restrict: 'E',
  bindings: {},
  controller,
  template
};

export default profileRegistryComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/profile/registry/registry.component.js
 **/